import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useSupplierInventoryImportStatusReducer = () =>
	useSelector((state: ApplicationState) => state.supplierInventoryImportStatus);
